import { createAction, props } from '@ngrx/store';

import type { Data } from 'src/app/utils/models/data.interface';

export enum RuntimeVariablesActionType {
  Update = '[Runtime] Update variables'
}

// Properties that are being updated using this method need to be registered in runtime-variables.enum.ts
export const runtimeVariablesUpdate = createAction(RuntimeVariablesActionType.Update, props<{ payload: Data }>());
